// NovaRush™ Premium Scroll Animations
document.addEventListener('DOMContentLoaded', function() {

  // Intersection Observer for fade-in-up animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  // Apply animation to sections
  const sections = document.querySelectorAll(
    '.section, [class*="section"], .featured-collection, .rich-text, .multicolumn'
  );

  sections.forEach(section => {
    section.classList.add('fade-in-up');
    observer.observe(section);
  });

});
// NovaRush™ Hero Slideshow
(function() {
  function initHeroSlideshow() {
    const slides = document.querySelectorAll('.hero__media-item, .hero__slide, [class*="hero"] .media');
    if (slides.length < 2) return;

    let current = 0;

    // Ocultar todos menos el primero
    slides.forEach((slide, i) => {
      slide.style.transition = 'opacity 0.8s ease';
      slide.style.position = i === 0 ? 'relative' : 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.opacity = i === 0 ? '1' : '0';
      slide.style.zIndex = i === 0 ? '1' : '0';
    });

    // Contenedor relativo
    const container = slides[0].parentElement;
    container.style.position = 'relative';
    container.style.overflow = 'hidden';

    // Rotar cada 5 segundos
    setInterval(() => {
      slides[current].style.opacity = '0';
      slides[current].style.zIndex = '0';
      current = (current + 1) % slides.length;
      slides[current].style.opacity = '1';
      slides[current].style.zIndex = '1';
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSlideshow);
  } else {
    initHeroSlideshow();
  }
})();
